import { render } from "./ActiveEventDetails.vue?vue&type=template&id=9a8c4178&scoped=true"
import script from "./ActiveEventDetails.vue?vue&type=script&lang=js"
export * from "./ActiveEventDetails.vue?vue&type=script&lang=js"

import "./ActiveEventDetails.vue?vue&type=style&index=0&id=9a8c4178&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a8c4178"]])

export default __exports__